var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotification24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-notification-24_svg__clip0_998_21)",
    fill: "#002147"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 17.5a1.5 1.5 0 01-1.5-1.5v-4.86A8 8 0 0013 3.07V1a1 1 0 00-2 0v2.07a8 8 0 00-6.5 8.07V16A1.5 1.5 0 013 17.5a1 1 0 000 2h18a1 1 0 000-2zM14.24 21H9.76a.25.25 0 00-.24.22 2.642 2.642 0 000 .28 2.5 2.5 0 105 0 2.615 2.615 0 000-.28.249.249 0 00-.28-.22z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-notification-24_svg__clip0_998_21"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgIconNotification24;